__turbopack_context__.v({
  "adminList": "auth-module__A_DBwq__adminList",
  "buttonContent": "auth-module__A_DBwq__buttonContent",
  "card": "auth-module__A_DBwq__card",
  "copy": "auth-module__A_DBwq__copy",
  "correctLabel": "auth-module__A_DBwq__correctLabel",
  "dangerButton": "auth-module__A_DBwq__dangerButton",
  "dialogClose": "auth-module__A_DBwq__dialogClose",
  "dialogHeading": "auth-module__A_DBwq__dialogHeading",
  "emailPill": "auth-module__A_DBwq__emailPill",
  "error": "auth-module__A_DBwq__error",
  "eyebrow": "auth-module__A_DBwq__eyebrow",
  "feedbackCorrect": "auth-module__A_DBwq__feedbackCorrect",
  "feedbackWrong": "auth-module__A_DBwq__feedbackWrong",
  "field": "auth-module__A_DBwq__field",
  "form": "auth-module__A_DBwq__form",
  "gameCard": "auth-module__A_DBwq__gameCard",
  "gamesList": "auth-module__A_DBwq__gamesList",
  "helperLink": "auth-module__A_DBwq__helperLink",
  "helperText": "auth-module__A_DBwq__helperText",
  "inlineSpinner": "auth-module__A_DBwq__inlineSpinner",
  "lineBreak": "auth-module__A_DBwq__lineBreak",
  "logoutForm": "auth-module__A_DBwq__logoutForm",
  "optionButton": "auth-module__A_DBwq__optionButton",
  "optionCorrect": "auth-module__A_DBwq__optionCorrect",
  "optionWrong": "auth-module__A_DBwq__optionWrong",
  "optionsGrid": "auth-module__A_DBwq__optionsGrid",
  "page": "auth-module__A_DBwq__page",
  "playbackButton": "auth-module__A_DBwq__playbackButton",
  "playbackProgress": "auth-module__A_DBwq__playbackProgress",
  "playbackRail": "auth-module__A_DBwq__playbackRail",
  "playbackTrack": "auth-module__A_DBwq__playbackTrack",
  "primaryButton": "auth-module__A_DBwq__primaryButton",
  "pulse": "auth-module__A_DBwq__pulse",
  "questionBlock": "auth-module__A_DBwq__questionBlock",
  "secondaryButton": "auth-module__A_DBwq__secondaryButton",
  "sentenceLine": "auth-module__A_DBwq__sentenceLine",
  "sentencePlaybackLayout": "auth-module__A_DBwq__sentencePlaybackLayout",
  "sessionCard": "auth-module__A_DBwq__sessionCard",
  "shake": "auth-module__A_DBwq__shake",
  "spin": "auth-module__A_DBwq__spin",
  "statsCard": "auth-module__A_DBwq__statsCard",
  "statsTable": "auth-module__A_DBwq__statsTable",
  "tableWrapper": "auth-module__A_DBwq__tableWrapper",
  "textToken": "auth-module__A_DBwq__textToken",
  "topBar": "auth-module__A_DBwq__topBar",
  "topicActions": "auth-module__A_DBwq__topicActions",
  "topicForm": "auth-module__A_DBwq__topicForm",
  "trainingLayout": "auth-module__A_DBwq__trainingLayout",
  "translationDialog": "auth-module__A_DBwq__translationDialog",
  "vocabularyPrompt": "auth-module__A_DBwq__vocabularyPrompt",
  "wordCard": "auth-module__A_DBwq__wordCard",
  "wordCardCorrect": "auth-module__A_DBwq__wordCardCorrect",
  "wordCardPlaying": "auth-module__A_DBwq__wordCardPlaying",
  "wordCardQuestion": "auth-module__A_DBwq__wordCardQuestion",
  "wordCardWrong": "auth-module__A_DBwq__wordCardWrong",
  "wordTranslation": "auth-module__A_DBwq__wordTranslation",
});
